import { createSlice } from '@reduxjs/toolkit';

interface ProjectSource {
  debt: number;
  equity: number;
  other: number;
}

const initialState: ProjectSource = {
  debt: 0,
  equity: 0,
  other: 0,
};

const ProjectSourceSlice = createSlice({
  name: 'projectSource',
  initialState,
  reducers: {
    set(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { set } = ProjectSourceSlice.actions;
export default ProjectSourceSlice.reducer;
